// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"164":"ce55fbd1","179":"ce946bad","342":"10670900","637":"a33d0b46","787":"99266118","871":"c7521770"}[chunkId] + ".css";
};